/**
 * Tenant/Client Configuration for Mobile PWA
 *
 * Tenant name loaded via VITE_TENANT_NAME env var at build time.
 * "Prisma" is the app name; the tenant name is the merchandising company.
 */

export const TENANT_NAME = import.meta.env.VITE_TENANT_NAME || 'NossoClube';
